// Core
import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'

// PropTypes
const { string, array, func } = PropTypes
const propTypes = {
  value: string,
  options: array.isRequired,
  onChange: func.isRequired
}

const defaultProps = {
  value: null
}

const SelectOperator = ({ value, options, onChange }) => (
  <div style={{ display: 'inline', fontWeight: 'bold' }}>
    <Select
      style={{ width: 150 }}
      allowClear={false}
      value={value || undefined}
      placeholder="请选择逻辑..."
      onChange={onChange}
      dropdownMatchSelectWidth={false}
      showSearch
    >
      {options.map(option => (
        <Select.Option value={option.signature}>{option.label}</Select.Option>
      ))}
    </Select>
  </div>
)

SelectOperator.propTypes = propTypes
SelectOperator.defaultProps = defaultProps

export default SelectOperator
